import { FC } from 'react';
import cx from 'classnames';

import styles from './CryptoLabelPill.module.sass';

interface CryptoLabelPillProps {
  iconUrl: string;
  label: string;
  protocol?: string;
  abbr: string;
  className?: string;
}

const CryptoLabelPill: FC<CryptoLabelPillProps> = ({
  iconUrl,
  label,
  protocol,
  abbr,
  className,
}) => {
  const classes = cx(styles.crypto, className);

  return (
    <div className={classes}>
      <div className={styles.icon}>
        <img src={iconUrl} alt={styles.label} />
      </div>
      <div className={styles.inner}>
        <div className={styles.label}>{label}</div>
        {protocol && <div className={styles.protocol}>{protocol}</div>}
      </div>
      {abbr && <div className={styles.abbr}>{abbr}</div>}
    </div>
  );
};

export default CryptoLabelPill;
